import React, { useState, useEffect } from 'react'
import {
  createTheme,
  ThemeProvider,
  Checkbox,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Grid,
  Box
} from '@mui/material';
import { USER_CHECK_LIST, USER_CHECK_LIST_SPANISH } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { initialClinic } from '../../api/APIServices';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';

const getMuiTheme = () => createTheme({
  components: {}
});

function UserCheckList() {
  const { t, i18n } = useTranslation('global');
  const { data } = useSelector((state) => state.user)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const params = useParams();
  const [open, setOpen] = useState(false);
  const [verifyIntakeQuestionnaire, setVerifyIntakeQuestionnaire] = useState(false);

  const [checked, setChecked] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(true);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setDisableSubmit(true)
    if (checked.length === USER_CHECK_LIST.length) {
      setDisableSubmit(false);
    }
  }, [checked]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleOnboarding = () => {
    dispatch(initialClinic({ "userId": data.userId, "visit": true }));
    handleClose();
    navigate(`/user_details/${data.userId}`);
  };

  let ListOfUsers = i18n?.language === 'en' ? USER_CHECK_LIST : USER_CHECK_LIST_SPANISH;

  useEffect(() => {
    if (data && data?.completedTasks) {
      let intakeQ = data?.completedTasks.filter((obj) => obj.taskId === 'q:intake')
      if (intakeQ && intakeQ.length === 1) {
        setVerifyIntakeQuestionnaire(true)
      }
    }
  }, [data]);

  return (
    <ThemeProvider theme={getMuiTheme()}>
      {data && false === ('intakeDate' in data) &&
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {/* Checklist Panel */}
          <Grid item xs={12} md={6}>
            <Box sx={{ border: 'solid 1px #ccc', p: 2 }}>
              <Typography sx={{ fontWeight: 600, fontSize: '16px' }}>
                {t('intakeChecklist')}
              </Typography>
            </Box>
            <Box sx={{ mt: 2, border: 'solid 1px #ccc', p: 2, height: { xs: 'auto', }, display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                  {ListOfUsers.map(({ id, name }) => {
                    const labelid = `checkbox-list-label-${id}`;
                    return (
                      <ListItem key={id} sx={{ pl: 0 }}>
                        <ListItemButton
                          sx={{
                            border: (checked.indexOf(id) !== -1) ? '1px solid #00C653' : '1px solid #ccc',
                            borderRadius: '10px',
                            mb: 1,
                            backgroundColor: (checked.indexOf(id) !== -1) ? '#00C6531A' : '#ffffff'
                          }}
                          onClick={handleToggle(id)} dense
                          disabled={id === 1 && !verifyIntakeQuestionnaire}
                        >
                          <ListItemText id={labelid} primary={`${name}`} />
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              value={name}
                              checked={checked.indexOf(id) !== -1}
                              tabIndex={1}
                              disableRipple
                              inputProps={{ 'aria-labelledby': labelid }}
                            />
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  type="submit"
                  color='primary'
                  variant="contained"
                  autoFocus
                  disabled={disableSubmit}
                  sx={{ borderRadius: '20px' }}
                  onClick={handleClickOpen}
                >
                  {t('submit')}
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Instructions Panel */}
          <Grid item xs={12} md={6}>
            <Box sx={{ border: 'solid 1px #ccc', p: 2, height: { xs: 'auto', md: '100%' }, overflow: 'auto' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '16px', mb: 2 }}>
                {t('clinicianInstructions')}
              </Typography>
              {[
                { title: t('intakeQuestionnaire'), text: t('qTextIntek') },
                { title: t('educationalVideos'), text: t('eTextIntek') },
                { title: t('sensorPlacement'), text: t('sTextIntek') },
                { title: t('pairSensor'), text: t('pTextIntek') },
                { title: "MVC, STS, TUG", text: t('mvcTextIntek') },
                { title: t('exercise'), text: t('exeTextIntek') }
              ].map(({ title, text }, idx) => (
                <Typography key={idx} paragraph className="checklistInstruction" sx={{ mb: 2 }}>
                  <Typography component="span" sx={{ fontWeight: 700, fontSize: '14px', mr: 1 }}>
                    {title} :
                  </Typography>
                  {text}
                </Typography>
              ))}
            </Box>
          </Grid>
        </Grid>
      }

      {/* Confirmation Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("intake_confirmation_message")}</DialogTitle>
        <DialogActions>
          <Button sx={{ borderRadius: '20px' }} onClick={handleOnboarding}>{t('yes')}</Button>
          <Button color='primary' size='small' variant="contained" onClick={handleClose} sx={{ borderRadius: '20px' }}>
            {t('no')}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}

export default UserCheckList;
